/* unplugin-vue-components disabled */import script from "./SelectModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectModal.vue?vue&type=script&setup=true&lang=js"

import "./SelectModal.vue?vue&type=style&index=0&id=3d6bd268&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d6bd268"]])

export default __exports__